export default "__VITE_ASSET__b0c47cb2__"